import fetch from './index'

// export function getStoreList(params): any {
//   return fetch.get('/edata/shops', { params })
// }
export function getStoreList(params): any {
  return fetch.get('/edata/shops/erp', { params })
}

export function addStore(params): any {
  return fetch.post('edata/shops/batch', params)
}

export function editStore(shopId, params): any {
  return fetch.put(`/edata/shops/${shopId}`, params)
}

export function getStoreDataList(params): any {
  return fetch.get('edata/shops/data', { params })
}

export function getOnlyFavorShopData(): any {
  return fetch.get('/edata/shops/id/favor')
}

export function getStoreDataDetail(shopId, params): any {
  return fetch.get(`edata/shops/data/${shopId}/details`, { params })
}

// 品类列表
export function getEdataCategory(): any {
  return fetch.get('/edata/review/data/category')
}

export function getProDataList(params): any {
  return fetch.post(`/edata/shops/data/items`, params)
}

export function putProDataStatus(params): any {
  return fetch.put(`/edata/shops/data/items/status`, {}, { params })
}
// 商品数据标题修改记录
export function getProDataTitleHistory(params): any {
  return fetch.get(`/edata/shops/data/items/data/change/title`, { params })
}
// 商品数据Tags修改记录
export function getProDataTagsHistory(params): any {
  return fetch.get(`/edata/shops/data/items/data/change/tags`, { params })
}

export function getProDataDetail(params): any {
  return fetch.get(`/edata/shops/data/items/details`, { params })
}

export function getProDataDetailSales(params): any {
  return fetch.get(`/edata/shops/data/items/sales`, { params })
}

export function putShopTop(shopId, params): any {
  return fetch.put(`/edata/shops/tops/${shopId}`, {}, { params })
}

export function getInternalList(params): any {
  return fetch.post(`/edata/internal/data/list`, params)
}

export function addInternal(params): any {
  return fetch.post(`/edata/internal/data`, params)
}

export function putInternal(params): any {
  return fetch.put(`/edata/internal/data`, params)
}

export function importInternal(params): any {
  return fetch.post(`/edata/internal/data/import`, params)
}
// 内部店铺数据-同比
export function getInternalYoyData(params): any {
  return fetch.post('/edata/internal/data/list/yoy', params)
}
// 内部店铺数据-环比
export function getInternalQoqData(params): any {
  return fetch.post('/edata/internal/data/list/qoq', params)
}
// 内部店铺数据-查询etsy关联渠道合计
export function getEtsyChannels(): any {
  return fetch.get('/edata/internal/data/channel')
}
// 内部店铺数据-设置etsy关联渠道合计
export function editEtsyChannels(params): any {
  return fetch.put('/edata/internal/data/channel', params)
}

// 内部店铺汇总数据
export function edataAggregation(params): any {
  return fetch.post(`/edata/internal/data/list/aggregation`, params)
}
// 内部店铺汇总数据-同比
export function getInternalYoyAggregationData(params): any {
  return fetch.post('edata/internal/data/list/aggregation/yoy', params)
}
// 内部店铺汇总数据-环比
export function getInternalQoqAggregationData(params): any {
  return fetch.post('edata/internal/data/list/aggregation/qoq', params)
}

// 查询etsy/独立站关联渠道数据
export function dataRelation(params?: any): any {
  return fetch.get(`/edata/internal/data/relation`, { params })
}

// 修改etsy/独立站关联渠道数据
export function saveDataRelation(params?: any): any {
  return fetch.put(`/edata/internal/data/relation`, params)
}

export function deleteInternal(id): any {
  return fetch.delete(`/edata/internal/data/${id}`)
}

export function importStore(params): any {
  return fetch.post(`/eps/edata/stone/quote/import`, params)
}


// 询单统计列表
export function orderSelectorList(params): any {
  return fetch.post(`/edata/enquiry/order/data/page`, params)
}

// 询单统计新增
export function orderSelectorAdd(params): any {
  return fetch.post(`/edata/enquiry/order/data/`, params)
}

// 询单统计编辑
export function orderSelectorEdit(params): any {
  return fetch.put(`/edata/enquiry/order/data/`, params)
}

// 询单统计删除
export function orderSelectorDelete(id): any {
  return fetch.delete(`/edata/enquiry/order/data/${id}`)
}

// 询单统计导入
export function orderSelectorImport(params): any {
  return fetch.post(`/edata/enquiry/order/data/import`, params)
}

// 邮箱发送模板list
export function getTemplateList(params): any {
  return fetch.post(`/edata/shop/email/template/list`, params)
}

export function saveTemplate(params): any {
  return fetch.post(`/edata/shop/email/template`, params)
}

export function saveTemplateCopy(params): any {
  return fetch.post(`/edata/shop/email/template/copy?templateId=${params.templateId}&salesChannelIds=${params.salesChannelIds}`, {})
}

export function editTemplate(params): any {
  return fetch.put(`/edata/shop/email/template`, params)
}

export function deleteTemplate(id): any {
  return fetch.delete(`/edata/shop/email/template/${id}`)
}

// 好/差关键词获取
export function getKeywords(params?: any): any {
  return fetch.get(`/edata/review/data/keywords`, { params })
}

// 好/差关键词保存
export function saveKeywords(params?: any): any {
  return fetch.post(`/edata/review/data/keywords`, params)
}

export function getReviewList(params?: any): any {
  return fetch.post(`/edata/review/data/list`, params)
}

export function getEmailAvg(params?: any): any {
  return fetch.get(`/edata/shop/email/data/avg`, { params })
}

export function postEmailAvg(params?: any): any {
  return fetch.post(`/edata/shop/email/data/avg`, params)
}

export function postEmailAnalysis(params?: any): any {
  return fetch.post(`/edata/shop/email/data/analysis`, params)
}

export function getCountry(params?: any): any {
  return fetch.get(`/edata/shop/email/data/country`, { params })
}

export function getFrequency(params?: any): any {
  return fetch.post(`/edata/review/data/frequency`, params)
}

export function getDashboard(params?: any): any {
  return fetch.get(`/edata/shops/dashboard`, { params })
}

export function getDashboardDetail(params?: any): any {
  return fetch.get(`/edata/shops/dashboard/detail`, { params })
}

export function saveDashboardRemark(params?: any): any {
  return fetch.post(`/edata/shops/save/data/remark`, params)
}

export function getShopTagsList(params?: any): any {
  return fetch.get(`/edata/shop/tags`, { params })
}

export function postShopTagsList(params?: any): any {
  return fetch.post(`/edata/shop/tags`, params)
}

export function putShopTagsList(params?: any): any {
  return fetch.put(`/edata/shop/tags`, params)
}

export function deleteShopTagsList(params?: any): any {
  return fetch.delete(`/edata/shop/tags`, { params })
}

export function batchShopTags(params?: any): any {
  return fetch.put(`/edata/shops/batch/update/tag`, params)
}
// 收藏店铺
export function favorEdataShop(params?: any): any {
  return fetch.post(`/edata/shops/favor`, params)
}
// 取消收藏
export function cancelFavorEdataShop(params?: any): any {
  return fetch.post(`/edata/shops/favor/cancel`, params)
}
// 查看已收藏店铺
export function getFavoredEdataShop(): any {
  return fetch.get('/edata/shop/favor')
}
// 大盘数据
export function getEdataShopAggregation(params): any {
  return fetch.get('/edata/shops/data/aggregation', { params })
}
// 关注店铺数据
export function getEdataCareShopAggregation(params): any {
  return fetch.get('/edata/shops/data/shop/aggregation', { params })
}
// 独立站埋点
export function postAccessHistory(params?: any): any {
  return fetch.post(`/idp/access/history/page`, params)
}
// 大盘排名数据
export function getEdataShopRank(params): any {
  return fetch.get('/edata/shops/data/rank', { params })
}
// 店铺运营动作
export function getOperationShopData(params?: any): any {
  return fetch.post(`/edata/operation/action/shop`, params)
}
// 商品运营动作
export function getOperationItemData(params?: any): any {
  return fetch.post(`/edata/operation/action/item`, params)
}
// 获取运营动作类型
export function getEdataOperationType(belong): any {
  return fetch.get(`/edata/operation/action/type/${belong}`)
}
// 店铺BS分析
export function getOperationBsShopData(params?: any): any {
  return fetch.post(`/edata/operation/action/bs/shop`, params)
}
// 商品数据异常处理
export function setShopsDataEventDelete(id): any {
  return fetch.post(`/edata/shops/data/items/event/delete?id=${id}`, {})
}

// 商品BS分析
export function getOperationBsItemData(params?: any): any {
  return fetch.post(`/edata/operation/action/bs/item`, params)
}

export function postHistoryStatistic(params?: any): any {
  return fetch.post(`/idp/access/history/statistic`, params)
}
// 流量数据导入
export function importDataItemsFlow(params?: any): any {
  return fetch.post(`/edata/shops/data/items/import`, params)
}
// 查询已关注商品
export function getEdataAttentionItem(params?: any): any {
  return fetch.post(`/edata/attention/item/page`, params)
}
// 新增关注商品
export function addEdataAttentionItem(params?: any): any {
  return fetch.post(`/edata/attention/item/batch`, params)
}
// 删除关注商品 
export function delEdataAttentionItem(id?: any): any {
  return fetch.delete(`/edata/attention/item/${id}`)
}
// 批量删除关注商品
export function delBatchEdataAttentionItem(params?: any): any {
  return fetch.post(`/edata/attention/item/cancel/batch`, params)
}
// 查看商品售价/折扣值历史记录
export function getShopItemLogList(params): any {
  return fetch.get('/edata/shops/log/List', { params })
}
// 独立站分析数据
export function postHistoryStatisticCompare(params?: any): any {
  return fetch.post(`/idp/access/history/statistic/compare`, params)
}
// 独立站分析数据环比 
export function postHistoryStatisticCompareqoq(params?: any): any {
  return fetch.post(`/idp/access/history/statistic/compare/qoq`, params)
}
// 独立站分析数据同比
export function postHistoryStatisticCompareyoy(params?: any): any {
  return fetch.post(`/idp/access/history/statistic/compare/yoy`, params)
}
// 查询关键词
export function getEdataKeysords(): any {
  return fetch.get('/edata/item/watch/data/elite/keywords')
}
// 查询选品池商品列表
export function postElite(params?: any): any {
  return fetch.post(`/edata/item/watch/data/elite/page`, params)
}
// 查询所有类目信息
export function getEliteCategory(params?: any): any {
  return fetch.get(`/edata/item/watch/data/elite/category/name/all`, {params})
}
// 查询所有店铺信息
export function getEliteShop(params?: any): any {
  return fetch.get(`/edata/item/watch/data/elite/shop/name/all`, {params})
}
// 
export function getElitewatch(params?: any): any {
  return fetch.put(`/edata/item/watch/data/elite/analy/status/batch/update`, params)
}
// 查询内部店铺目标
export function getInternalStoreData(params?: any): any {
  return fetch.post(`/edata/internal/store/goal/data/page`, params)
}
// 新增内部店铺目标
export function addInternalStoreData(params?: any): any {
  return fetch.post(`/edata/internal/store/goal/data`, params)
}
// 编辑内部店铺目标
export function editInternalStoreData(params?: any): any {
  return fetch.put(`/edata/internal/store/goal/data`, params)
}
// 删除内部店铺目标
export function delInternalStoreData(id): any {
  return fetch.delete(`/edata/internal/store/goal/data/${id}`)
}
// 查询内部店铺预警
export function getInternalStoreWarn(params?: any): any {
  return fetch.post(`/ealry/warn/page`, params)
}
// 新增内部店铺预警
export function addInternalStoreWarn(params?: any): any {
  return fetch.post(`/ealry/warn`, params)
}
// 编辑内部店铺预警
export function editInternalStoreWarn(params?: any): any {
  return fetch.put(`/ealry/warn`, params)
}
// 删除内部店铺预警
export function delInternalStoreWarn(id): any {
  return fetch.delete(`/ealry/warn/${id}`)
}
// 查询商品BS设置
export function getInternalItemBsData(params?: any): any {
  return fetch.post(`/edata/internal/store/bs/data/page`, params)
}
// 新增商品BS设置
export function addInternalItemBsData(params?: any): any {
  return fetch.post(`/edata/internal/store/bs/data`, params)
}
// 编辑商品BS设置
export function editInternalItemBsData(params?: any): any {
  return fetch.put(`/edata/internal/store/bs/data`, params)
}
// 删除商品BS设置
export function delInternalItemBsData(id): any {
  return fetch.delete(`/edata/internal/store/bs/data/${id}`)
}
// 首页大盘-店铺预警信息
export function getHomeInternalStoreWarnData(params): any {
  return fetch.get(`/edata/internal/store/warn`, {params})
}
// 添加定款池
export function addDesignPool(params): any {
  return fetch.post(`/edata/design/settlement`, params)
}
// 搜索定款池
export function searchDesignPool(params): any {
  return fetch.post(`/edata/design/settlement/page`, params)
}
// 审核定款池
export function auditDesignPool(params): any {
  return fetch.put(`/edata/design/settlement/audit`, params)
}
// 编辑定款池
export function putauditDesignPool(params): any {
  return fetch.put(`/edata/design/settlement`, params)
}
// 删除定款池
export function deleteDesignPool(params): any {
  return fetch.delete(`/edata/design/settlement/${params?.id}`)
}
// 定款池打版
export function daDesignPool(params): any {
  return fetch.post(`/edata/design/pattern/add/settlement`, params)
}
// 属性词
export function postAnalysisPool(params): any {
  return fetch.post(`/edata/item/watch/data/elite/analysis`, params)
}
// 查询打版数据
export function searchDBPool(params): any {
  return fetch.post(`/edata/design/pattern/page`, params)
}
export function addDBPool(params): any {
  return fetch.post(`/edata/design/pattern`, params)
}
// 删除打版数据
export function delDBPool(id): any {
  return fetch.delete(`/edata/design/pattern/${id}`)
}
// 外部商品打版
export function addOutDBPool(params): any {
  return fetch.post(`/edata/design/settlement`, params)
}
// 批量回货
export function batchPatternItemReturn(ids): any {
  return fetch.put(`/edata/design/pattern/item/return?ids=${ids}`)
}
// 批量暂定启动
export function batchPatternItemWatch(ids, flag): any {
  return fetch.put(`/edata/design/pattern/watch?ids=${ids}&watchFlag=${flag}`)
}

export function editDBPool(params): any {
  return fetch.put(`/edata/design/pattern`, params)
}
// 查询系统定时任务执行状态
export function getEdataShopsDataTimesTaskStatus(): any {
  return fetch.get(`/edata/shops/data/items/task/status`)
}
// 店铺产品数据新增
export function addEdataProductData(params): any {
  return fetch.post(`/edata/product/data`, params)
}
// 店铺产品数据编辑
export function editEdataProductData(params): any {
  return fetch.put(`/edata/product/data`, params)
}
// 店铺产品数据删除
export function delEdataProductData(id): any {
  return fetch.delete(`/edata/product/data/${id}`)
}
// 店铺产品数据查询
export function getEdataProductData(params): any {
  return fetch.post(`/edata/product/data/page`, params)
}
// 店铺产品数据导入
export function importEdataProductData(params): any {
  return fetch.post(`/edata/product/data/import`, params)
}
// 店铺产品数据导出
export function exportEdataProductData(params): any {
  return fetch.post(`/export/records/product/data`, params)
}
// 产品信息新增
export function addEdataProductDataDetail(params): any {
  return fetch.post(`/edata/product/data/detail`, params)
}
// 产品信息编辑
export function editEdataProductDataDetail(params): any {
  return fetch.put(`/edata/product/data/detail`, params)
}
// 产品信息删除
export function delEdataProductDataDetail(id): any {
  return fetch.delete(`/edata/product/data/detail/${id}`)
}
// 产品信息查询
export function getEdataProductDataDetail(params): any {
  return fetch.post(`/edata/product/data/detail/page`, params)
}
// 店铺进选品池关键词分析
export function getEdataShopItemKeywordAnalysis(params): any {
  return fetch.post(`/edata/item/watch/data/elite/title/analysis`, params)
}
// 商品数据导出
export function exportEdataItems(params): any {
  return fetch.post(`/export/records/shops/data/items`, params)
}
// 询单信息查询
export function getEdataConversationData(params): any {
  return fetch.post(`/edata/conversation/page`, params)
}
// 询单咨询主题/痛点候选值(服务端按库内真实 AI 标签去重,与筛选值域同源;前端不再硬编码)
export function getEdataConversationTagOptions(): any {
  return fetch.get(`/edata/conversation/tag/options`, { noLoading: true })
}
// 询单信息编辑
export function editEdataConversationData(params): any {
  return fetch.put(`/edata/conversation`, params)
}
// 询单产品信息查询
export function getEdataProductConversationData(params): any {
  return fetch.post(`/edata/conversation/product/page`, params)
}
// 询单变更历史记录
export function getEdataConversationEditLog(params): any {
  return fetch.post(`/edata/conversation/log/page`, params)
}
// 弃单飞书统计结果
export function getFeishuSheetShopifyAbandoned(params): any {
  return fetch.post(`/edata/feishu/sheet/shopify/abandoned/order/query`, params)
}
// 弃单数据统计并保存飞书
export function saveFeishuSheetShopifyAbandoned(params): any {
  return fetch.post(`/edata/feishu/sheet/shopify/abandoned/order/save`, params)
}
// 弃单数据本地查看（读本地库按站富列返回，非飞书）
export function queryLocalShopifyAbandoned(params): any {
  return fetch.post(`/edata/feishu/sheet/shopify/abandoned/order/query/local`, params)
}
// 全部站点查询
export function getShopifySiteSignConfigAll(): any {
  return fetch.post(`/edata/shopify/site/sign/config/all`, {})
}